import { Box, Link, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";

const useScriptStyles = makeStyles(theme => ({
    goto: {
        fontFamily: "inherit",
        textAlign: "right",
        marginRight: "20mm",
    },
}));

interface Props
{
    pages: { [state: string]: number }
    paragraphs: { [state: string]: number }
    state: string
    trigger?: string
}
export function Goto({ paragraphs, pages, state, trigger }: Props)
{
    const classes = useScriptStyles();
    const triggerText = trigger ? `${trigger}: ` : "";
    if (!pages[state])
    {
        console.warn("Goto missing page", state, trigger)
    }

    if (!paragraphs[state])
    {
        console.warn("Goto missing paragraph", state, trigger);
    }
    const pageText = `Go to page ${pages[state]}, para ${paragraphs[state]}`;
    return (
        <Box title={state}>
            <Box display="block" displayPrint="none">
                <Typography className={`NoExport ${classes.goto}`}>
                    {triggerText}
                    <Link onClick={() =>
                        document.getElementById(`paragraph-${paragraphs[state]}`)?.scrollIntoView({
                            behavior: "smooth"
                        })
                    } sx={{ cursor: "pointer" }}>
                        {pageText}
                    </Link>
                </Typography>
            </Box>
            <Box display="none" displayPrint="block">
                <Typography className={`GoTo ${classes.goto}`}>
                    {triggerText}
                    {pageText}
                </Typography>
            </Box>
        </Box>
    );
}
